import {Article} from "./article.model";

export class ArticleArticle {
  id?: number;
  relatedArticleId?: number;
  relatedArticle?: Article;

  assigned?: boolean;
}
